import $ from 'jquery';
import { component as defineComponent } from 'flightjs';
import withAsimov from 'app/modules/mixins/with-asimov';
import withDependentFields from 'app/modules/mixins/with-dependent-fields';

function BriefForm() {
    this.attributes({
        submitSelector: '[type="submit"]',
    });

    this.submitClicked = function(e, data) {
        if ($(data.el).data('needs-auth') === true) {
            e.preventDefault();

            this.trigger('authenticationRequested', {
                source: $(data.el).attr('id'),
            });
        }
    };

    this.authenticationSuccessful = function(e, data) {
        $('#' + data.source)
            .data('needs-auth', false)
            .click();
    };

    this.after('initialize', function() {
        this.on(document, 'authenticationSuccessful', this.authenticationSuccessful);

        this.on('click', {
            submitSelector: this.submitClicked,
        });

        /**
         * Deactivates auto save to avoid race condition of auto save
         * overriding the form post.
         */
        this.on('submit', function() {
            this.trigger('autosaveDeactivateRequested');
        });
    });
}

export default defineComponent(BriefForm, withAsimov, withDependentFields);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/brief-form.js